import { render, staticRenderFns } from "./ChatTinder.vue?vue&type=template&id=2557393a&"
import script from "./ChatTinder.vue?vue&type=script&lang=js&"
export * from "./ChatTinder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports